import React, { useState, useEffect } from 'react';
import { Table, Space, Row, Col, Spin, Button, message, Popconfirm} from 'antd';
import { 
  TableWrapper, 
  ProjectEditModal, 
  ProjectAskEditModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import { TotalNumMenu } from 'components/atoms';
import { addNewSearch } from 'utils/utils';
import { useTableInfo } from 'hooks';
import { INIT_PAGESIZE, MY_PROJECT_GROUP_TYPE } from 'commons/constants';
import { useLocation, useNavigate } from 'react-router';
import { fetcher } from 'services';
import qs from 'query-string';
import * as XLSX from 'xlsx';
import { tableSortOrder } from 'utils/table-utils';
import { SortOrder } from 'antd/lib/table/interface';
import useStore from 'store'
import { SERVER_URL } from 'commons/constants';
import axios from 'axios';
import { endpoints } from 'services';

interface FormItemProps {
  askList: ProjectAskListDto[] | undefined;  
  searchResult: any;
  myPage: MY_PROJECT_GROUP_TYPE;
  refetch: () => void;
}

const B2BAskTable = ({askList, searchResult, myPage, refetch}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();
  const { open } = usePopupManager();
  const [rowExpaned, setRowExpaned] = useState<number[]>([]);  
  const searchParams = qs.parse(location.search);
  const [isLoding, setIsLoading] = useState<boolean>(false);  

  const auth = useStore((state) => state.auth); 

  const onCellClick = (record) => {
    return {
      onClick: (e) => {
        open(ProjectAskEditModal, {id: Number(record.id), onClose: (isOk)=>{if(isOk) {refetch();}}});         
      },
    };
   };

  const columns: ColumnsType<ProjectAskListDto> = [
    {
      title: '진행여부',
      dataIndex: 'checkYn',
      key: 'checkYn',
      width: '80px',
      align: 'center',
      render: (checkYn, record) => {
       return (
        <>
        {record.project.length > 0 ? (
          <Button
            type='default'
          >{checkYn===''?<span style={{color:'red'}}>?</span>:checkYn}
          </Button>
        ) : (
          <Popconfirm
            title="진행여부 상태를 변경 하시겠습니까?"
            okText="변경"
            cancelText="취소"
            onConfirm={(e) => {
              fetcher.project.postProjectAskUpdateCheck({
                id: record.id,
                checkYn: checkYn==='Y'?'N':checkYn==='N'?'Y':'N',
              })
              .then((res) => {
                  switch (res.code) {
                      case 200:
                          refetch();
                      break;
                      default:  
                      break;
                  };
              }); 
            }}
            >   
              <Button
                type='default'
              >{checkYn===''?<span style={{color:'red'}}>?</span>:checkYn}</Button>
          </Popconfirm>              
        )}
        </>
      )}  
    },  
    {
      title: '번호',
      dataIndex: 'id',
      key: 'id',
      width: '70px',
      align: 'center',
      onCell: (record) => {
        return {
            onClick: (e) => {
              if (rowExpaned.includes(record.id)) {
                setRowExpaned(rowExpaned.filter(item => item !== record.id) ) 
              } else {
                setRowExpaned(preRowExpaned => [...preRowExpaned, record.id])
              }              
            },
        };
      },        
    },  
    {
      title: '일자',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '120px',
      align: 'center',
      ellipsis: true,
      sorter: true,
      sortOrder: tableSortOrder(searchParams.order as string, 'created_at', searchParams.reverse as string) as SortOrder,
      showSorterTooltip: false,      
      onCell: onCellClick,
    },      
    {
      title: '고객사',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '150px',
      align: 'left', 
      ellipsis: true,  
      onCell: onCellClick,  
    },  
    {
      title: '강의구분',
      dataIndex: 'lecture_type1',
      key: 'lecture_type1',
      width: '120px',
      align: 'center',
      ellipsis: true,
      onCell: onCellClick,
    },
    {
      title: '강의주제',
      dataIndex: 'lecture_subject1',
      key: 'lecture_subject1',
      width: '120px',
      align: 'center',
      ellipsis: true,
      onCell: onCellClick,
    },  
    {
      title: '요청사항',
      dataIndex: 'request_memo',
      key: 'request_memo',
      width: 'auto',
      align: 'center',
      ellipsis: true,
      onCell: onCellClick,
    }, 
    {
      title: '기본대응',
      dataIndex: 'pm',
      key: 'pm',
      width: '70px',
      align: 'center',
      ellipsis: true,
      onCell: onCellClick,
    },     
    {
      title: 'F/U',
      dataIndex: 'pm2',
      key: 'pm2',
      width: '70px',
      align: 'center',
      ellipsis: true,
      onCell: onCellClick,
    }, 
    {
      title: '프로젝트',
      key: 'project',
      width: '80px',
      align: 'center',
      render: (record) => {
        return (
          <>
            <a onClick={(e) => {
              if (rowExpaned.includes(record.id)) {
                setRowExpaned(rowExpaned.filter(item => item !== record.id) ) 
              } else {
                setRowExpaned(preRowExpaned => [...preRowExpaned, record.id])
              }
            }}>{record.project.length}건</a>
          </>
        )
      }
    },
  ];

  /* ======================================================
  * events
  * ====================================================== */ 


 const onClickRegister = () => {
      open(ProjectAskEditModal, {id: 0, onClose: (isOk)=>{if(isOk) {refetch();}}});
 }

 const onChangePageInfo = (pageNo: number, pageSize: number) => {
   navigate({
     ...location,
     search: addNewSearch(location.search, { pageNo, pageSize }),
   });
 };  

  const onChangeSorters = (sorter: any)  => {
    const { order, field } = sorter;
    const reverse = order === 'ascend' ? 'Y' : '';

    navigate({
      ...location,
      search: addNewSearch(location.search, { pageNo: 1, order:field, reverse }),
    });  
  }; 

  const onNewExcelDownload = () => {
    setIsLoading(true); 
    axios({
      url: SERVER_URL + endpoints.project.ask.excel,
      method: 'post',
      responseType: 'arraybuffer',
      params: {
        pageNo: 1,
        pageSize: 0,
        searchValue: searchParams.search ? String(searchParams.search) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
        biz: searchParams.biz ? String(searchParams.biz) : '',  
        pm: searchParams.pm ? String(searchParams.pm) : '',  
        pm2: myPage === 'b2b5' ? ''+auth.login?.id : '',
        status: searchParams.status ? String(searchParams.status) : '',  
        lecture_type: searchParams.lecture_type ? String(searchParams.lecture_type) : '',  
        lecture_subject: searchParams.lecture_subject ? String(searchParams.lecture_subject) : '', 
        order: searchParams.order ? String(searchParams.order) : '',
        reverse: searchParams.reverse ? String(searchParams.reverse) : '',  
      },
    })
    .then((response) => {
      const fileName = `${myPage==='b2b5' ? 'my_b2b_문의' : 'b2b_문의'}.xlsx`;
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}`);
      link.style.cssText = 'display:none';
      document.body.appendChild(link);
      link.click();
      setIsLoading(false); 
    })
    .catch(() => {
      setIsLoading(false); 
      message.error('파일 다운로드 중 에러가 발생했습니다.', 1);      
    });     
  } 

  /* ======================================================
  * hooks
  * ====================================================== */
  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: Number(searchParams.pageNo) || 1,
      pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
    },
    datas: askList,
    totalCount: Number(searchResult.totalCount),    
    onChangePageInfo,
    onChangeSorters,
  });

  useEffect(() => {
    setRowExpaned([]);
  }, [searchResult.pageNo]); 

  const onExpaned = (val: boolean) => {
    if (val) {
      if (!!askList) {
        const rows: any[] = [];
        askList.forEach(record => {
          rows.push(record.id);
        })
        setRowExpaned(rows);
      }
    } else {
      setRowExpaned([]);
    }
  };

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%'}}>
      <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
        <TotalNumMenu onExpaned={onExpaned} totalNum={searchResult.totalCount} useRegister useExcelDownload onUseRegister={onClickRegister} onDownloadExcel={onNewExcelDownload}/>
        <TableWrapper isSearch={!!searchParams.search || !!searchParams.lecturer_type || !!searchParams.lecturer_category}>
          <Table
            tableLayout="fixed"
            dataSource={askList}
            columns={columns}
            pagination={pagination}
            onChange={onTableChange}
            sortDirections={["descend", "ascend"]}
            style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
            className="columnCenterFixTable clickable"
            showSorterTooltip={false}
            rowKey={'id'}
            expandable={{
              expandedRowRender: (record) => (
                <Space direction="vertical" style={{padding:"5px 17px", width:"100%"}} size={3}>
                {record.project.map((item)=>(   
                  <Row key={item.id} style={{padding:"0px"}} onClick={()=>{
                    open(ProjectEditModal, {
                      id: item.id,
                      pType: item.project_step == 'A' ? 'confirm' : item.project_step == 'D' ? 'drop' : 'consult',
                      onClose: (isOk) => {refetch();},
                    });                    
                  }}>
                    <Col flex={'80px'} style={{display:'flex', justifyContent:'center'}}>
                      <Button
                        type='default'
                      >{item.project_step == 'A'?'Y':item.project_step == 'D'?'N':<span style={{color:'red'}}>?</span>}</Button>                        
                    </Col>
                    <Col flex={'70px'} style={{display:'flex', justifyContent:'center'}}>{item.id}</Col>
                    <Col flex={'270px'} style={{paddingLeft:'29px'}}>{item.project_date}</Col>
                    <Col flex={'120px'} style={{display:'flex', justifyContent:'center'}}>{item.lecture_type}</Col>
                    <Col flex={'120px'} style={{display:'flex', justifyContent:'center'}}>{item.lecture_subject}</Col>                    
                    <Col flex={'auto'} style={{display:'flex', justifyContent:'center'}}>{item.title}</Col>
                    <Col flex={'150px'} style={{display:'flex', justifyContent:'center'}}>{item.target}</Col>
                  </Row>                                       
                ))}
                </Space>
              ),
              columnWidth: 25,
              expandedRowKeys: rowExpaned,
              onExpand: (expaned, record) => { 
                if (expaned) {
                  setRowExpaned(preRowExpaned => [...preRowExpaned, record.id])
                } else {
                  setRowExpaned(rowExpaned.filter(item => item !== record.id) ) 
                }
              },                
            }}
          />
        </TableWrapper> 
      </Spin>
    </Space>
  );
};

export default B2BAskTable;
